import { Search } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { displayCitationPage } from '@/lib/citation-preview'
import type { SectionCitation } from '@/lib/api'

const GROUP_LABELS: Record<SectionCitation['signalGroup'], string> = {
  instructions: 'prescribed structure',
  scope: 'scope signal',
  conditions: 'delivery signal',
}

/**
 * "Why this section" provenance chip — verbatim tender quote + page in a
 * popover. Same trust pattern as drafting citations.
 */
export function CitationChip({ citation }: { citation: SectionCitation }) {
  const page = displayCitationPage(citation.page)
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-1 rounded-lg border border-dashed border-[hsl(var(--ai-accent)/0.45)] px-1.5 py-0.5 text-xs text-[hsl(var(--ai-accent-text))] hover:bg-[hsl(var(--ai-accent-soft))]"
        >
          <Search className="h-3 w-3" />
          {citation.documentName.length > 24
            ? `${citation.documentName.slice(0, 24)}…`
            : citation.documentName}
          {page != null && ` · p.${page}`}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80" align="start">
        <p className="mb-1 text-[11px] font-medium text-muted-foreground">
          Why this section · {citation.documentName}
          {page != null && ` · p.${page}`} · {GROUP_LABELS[citation.signalGroup]}
        </p>
        <p className="text-xs leading-relaxed text-foreground">“{citation.quote}”</p>
      </PopoverContent>
    </Popover>
  )
}
